export function getAnonymousSessionId(): string {
  if (typeof window === "undefined") {
    return "server-session";
  }

  const STORAGE_KEY = "sr_job_session_id";
  let sessionId = localStorage.getItem(STORAGE_KEY);
  if (!sessionId) {
    sessionId = "anon_" + crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, sessionId);
  }
  return sessionId;
}
